<template>
    <div class="bookingManagementForm">
        <el-container>
            <el-header>
                <el-divider content-position="left">预约码管理</el-divider>
            </el-header>
            <el-container>
                <el-aside class="subscribeAside">
                    <el-container>
                        <el-main>
                            <el-image :src="subscribe_src"></el-image>
                        </el-main>
                        <el-aside>
                            <el-button type="success" plain size="small" :disabled="subscribe_src==''" @click="downloadQrCode(bookingQrCode, 1)">下载图片（72dpi）</el-button>
                            <el-button type="success" plain size="small" :disabled="subscribe_src==''" @click="downloadQrCode(bookingQrCode, 2)">下载图片（300dpi）</el-button>
                        </el-aside>
                    </el-container>
                </el-aside>
                <el-main>
                    <el-container>
                        <el-header class="subscribeIntro">预约码说明</el-header>
                        <el-main class="introduce">
                            <p>预约码说明：预约码是游客预约的途经之一，可以从线上线下两方面进行预约。</p>
                            <p>下载图片（72dpi）可以下载500*500 72dpi的图片，主要运用于线上宣传。</p>
                            <p>下载图片（300dpi）可以下载1200*1200 300dpi的大图，主要用于线下印刷。</p>
                        </el-main>
                    </el-container>
                </el-main>
            </el-container>
        </el-container>
        <el-container>
            <el-header>
                <el-divider content-position="left">自助核销码管理</el-divider>
            </el-header>
            <el-container>
                <el-aside class="destructionAside">
                    <el-container>
                        <el-main>
                            <el-image :src="destruction_src"></el-image>
                        </el-main>
                        <el-aside>
                            <el-button type="warning" plain size="small" :disabled="destruction_src==''" @click="downloadQrCode(verificationQrCode, 1)">下载图片（72dpi）</el-button>
                            <el-button type="warning" plain size="small" :disabled="destruction_src==''" @click="downloadQrCode(verificationQrCode, 2)">下载图片（300dpi）</el-button>
                        </el-aside>
                    </el-container>
                </el-aside>
                <el-main>
                    <el-container>
                        <el-header class="destructionIntro">自助核销码说明</el-header>
                        <el-main class="introduce">
                            <p>自助核销码说明：游客入园后通过自行扫码核销的二维码。此二维码主要针对没有或不需要核销员扫码核销的场景。</p>
                            <p>下载图片（72dpi）可以下载500*500 72dpi的图片。</p>
                            <p>下载图片（300dpi）可以下载1200*1200 300dpi的大图。</p>
                        </el-main>
                    </el-container>
                </el-main>
            </el-container>
        </el-container>
        <el-container>
            <el-header>
                <el-divider content-position="left">核销员</el-divider>
            </el-header>
            <el-main class="inspector">
                <el-button type="primary" @click="addInspector">添加核销员</el-button>
                <el-container>
                    <el-main class="checkmanList">
                        <el-form ref="inspectorForm" :model="inspectorForm" label-width="80px">
                            <el-container class="inspectorInfo" v-for="(item,index) in inspectorForm.checkmanList">
                                <el-aside>
                                    <el-form-item label="姓名"  :prop="'checkmanList.' + index +'.name'"
                                                  :rules="[
                                                  {type: 'string', required: true, message: '请输入姓名', trigger: 'blur'},
                                                  {type: 'string', pattern: validate.reg.noHtml, message: '只允许输入纯文本、符号', trigger: 'blur'}
                                              ]">
                                        <el-input v-model.trim="item.name" placeholder="请输入姓名" size="mini" maxlength="10"></el-input>
                                    </el-form-item>
                                    <el-form-item label="电话" :prop="'checkmanList.' + index +'.phone'" :rules=phoneRule>
                                        <el-input v-model.trim="item.phone" placeholder="请输入手机号" size="mini" maxlength="11"></el-input>
                                    </el-form-item>
                                    <el-button type="primary" plain size="mini" @click="createQrCode(item, index)">保存</el-button>
                                </el-aside>
                                <el-main>
                                    <el-image :src="item.qrCode"></el-image>
                                    <div class="inspectorTips" v-if="item.id==''"><p>请完善核销员信息，并点击左侧生成核销员二维码按钮</p></div>
                                </el-main>
                                <el-aside>
                                    <el-button type="success" plain size="small" @click="downloadQrCode(item.inspectorQrCode)" :disabled="item.qrCode==''||item.qrCode==dafault_qrcode">下载图片</el-button>
                                    <el-button type="danger" size="small" :disabled="item.id==''" @click="deleteInspector(item, index)">删除核销员</el-button>
                                </el-aside>
                            </el-container>
                        </el-form>
                    </el-main>
                </el-container>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import TemplateForm from "../../support/sword2/swordForm";

    export default {
        components: {TemplateForm},
        data() {
            const _this = this;
            const exitsPhone = function (rule, value, callback) {
                if (value !== "") {
                    let index = parseInt(rule.field.replace(/[^0-9]/ig,""));
                    let id = _this.inspectorForm.checkmanList[index].id;
                    if(!id){
                        id = '';
                    }
                    _this.request.get("/wtcp-booking/checkman/checkPhone", {
                        id: id,
                        phone:value
                    }).then(res => {
                        if (res.status === 1) {
                            return callback();
                        } else {
                            callback(new Error("该手机号已存在！"));
                        }
                    });
                }
            };
            return {
                inspectorForm: {
                    checkmanList: []
                },
                subscribe_src: '',
                destruction_src: '',
                bookingQrCode: '',
                verificationQrCode: '',
                inspector_src: '',
                pageload: true,
                fileBaseUrl: '',
                resId: '',
                dafault_qrcode: '',
                fields: {
                },
                phoneRule: [
                    {type: 'string', required: true, message: '请输入手机号', trigger: 'blur'},
                    {type: 'string', pattern: _this.validate.reg.mobile, message: '请输入正确的手机号', trigger: 'blur'},
                    {validator: exitsPhone, trigger: 'blur' }
                ]
            }
        },
        methods: {
            //加载页面
            loadPage() {
                this.pageload = true;
                const _this = this;
                _this.subscribe_src =  require('@/imgbox/default/default_qrcode.png');
                _this.destruction_src = require('@/imgbox/default/default_qrcode.png');
                this.request.get('/wtcp-booking/checkman/getInfo').then(res => {
                    if (res.status == 1) {
                        let configEntity = res.data.configEntity;
                        if(configEntity != null && JSON.stringify(configEntity) != "{}"){
                            _this.subscribe_src =  _this.fileBaseUrl + configEntity.bookingQrCode;
                            _this.destruction_src = _this.fileBaseUrl + configEntity.verificationQrCode;
                            _this.bookingQrCode = configEntity.bookingQrCode;
                            _this.verificationQrCode = configEntity.verificationQrCode;
                            _this.resId = configEntity.resId;
                        };
                        let checkmans = res.data.checkmans;
                        if(checkmans != null && checkmans.length > 0){
                            for (let i = 0; i < checkmans.length; i++){
                                checkmans[i].inspectorQrCode = checkmans[i].qrCode;
                                checkmans[i].qrCode = _this.fileBaseUrl + checkmans[i].qrCode;
                                _this.inspectorForm.checkmanList.push(checkmans[i]);
                            }
                        }
                    } else {
                        _this.$message({message: res.msg, type: "error"});
                    }
                    _this.pageload = false;
                })
            },
            SelectText(element) {
                let doc = document;
                if (doc.body.createTextRange) {
                    let range = document.body.createTextRange();
                    range.moveToElementText(element);
                    range.select();
                } else if (window.getSelection) {
                    let selection = window.getSelection();
                    let range = document.createRange();
                    range.selectNodeContents(element);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    console.log(selection);
                }
            },
            //复制图片
            copyQrCode(e){
                let thisImg = e.currentTarget.parentElement.previousElementSibling.firstElementChild;
                this.$set(thisImg, 'contenteditable' , true);
                //获取DOM元素，需document.querySelector（".qrcodeImg"）获取这个dom节点，然后再获取qrcodeImg的值。

                this.SelectText(thisImg.childNodes[0]); //取第一位   this调用了实例上的东西
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
                this.$delete(thisImg, "contenteditable");
                alert("二维码已复制!");
            },
            downloadIamge (imgsrc, name) { // 下载图片地址和图片名
                let image = new Image()
                // 解决跨域 Canvas 污染问题
                image.setAttribute('crossOrigin', 'anonymous')
                image.onload = function () {
                    let canvas = document.createElement('canvas')
                    canvas.width = image.width
                    canvas.height = image.height
                    let context = canvas.getContext('2d')
                    context.drawImage(image, 0, 0, image.width, image.height)
                    let url = canvas.toDataURL('image/jpeg') // 得到图片的base64编码数据
                    let a = document.createElement('a') // 生成一个a元素
                    let event = new MouseEvent('click') // 创建一个单击事件
                    a.download = name || 'photo' // 设置图片名称
                    a.href = url // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event) // 触发a的单击事件
                }
                image.src = imgsrc
            },
            //下载图片,type代表类型，1为500*500 72dpi；2为1200*1200 300dpi
            downloadQrCode(imgsrc, type){
                let access_token = this.request.getSession("userToken");
                if (imgsrc) {
                    imgsrc = imgsrc.replace(/\&/g, '_');
                }
                if(type == 1){
                    window.open('/api/wtcp-booking/checkman/downloadImageProcess?access_token='+access_token+"&path="+imgsrc+"&width=500&height=500&dpi=72");
                } else if(type == 2){
                    window.open('/api/wtcp-booking/checkman/downloadImageProcess?access_token='+access_token+"&path="+imgsrc+"&width=1200&height=1200&dpi=300");
                } else {
                    window.open('/api/wtcp-booking/checkman/downloadImage?access_token='+access_token+"&path="+imgsrc);
                }


            },
            //添加核销员
            addInspector(e){
                if(this.inspectorForm.checkmanList.length < 20){
                    this.inspectorForm.checkmanList.push(
                        {
                            name: '',
                            phone: '',
                            id: '',
                            qrCode: this.dafault_qrcode
                        }
                    )
                } else {
                    this.$message({message: '最多只能增加20个核销员！！！', type: 'warning'});
                }

            },
            //生成核销员二维码
            createQrCode(item, index){
                const _this = this;
                _this.$refs.inspectorForm.validateField('checkmanList.' + index +'.name', nameMsg => {
                    _this.$refs.inspectorForm.validateField('checkmanList.' + index +'.phone', phoneMsg => {
                        if(nameMsg == '' && phoneMsg == ''){
                            _this.submitForm(item, index);
                        }
                    });
                });
            },
            //提交表单
            submitForm(item, index){
                const _this = this;
                if (item.id != '') {
                    _this.request.put('/wtcp-booking/checkman/updateQrCode/' + item.id,item).then(res => {
                        if (res.status == 1) {
                            _this.inspectorForm.checkmanList[index].id = res.data.id;
                            _this.inspectorForm.checkmanList[index].qrCode = _this.fileBaseUrl +  res.data.qrCode;
                            _this.inspectorForm.checkmanList[index].inspectorQrCode = res.data.qrCode;
                            this.$message({message: '保存成功', type: 'success'});
                        } else {
                            _this.$message({message: res.msg, type: "error"});
                        }
                        _this.pageload = false;
                    })
                } else {
                    item.resId = _this.resId;
                    _this.request.post('/wtcp-booking/checkman',item).then(res => {
                        if (res.status == 1) {
                            _this.inspectorForm.checkmanList[index].id = res.data.id;
                            _this.inspectorForm.checkmanList[index].qrCode = _this.fileBaseUrl +  res.data.qrCode;
                            _this.inspectorForm.checkmanList[index].inspectorQrCode = res.data.qrCode;
                            _this.$message({message: '保存成功', type: 'success'});
                        } else {
                            _this.$message({message: res.msg, type: "error"});
                        }
                        _this.pageload = false;
                    });
                }

            },
            //删除核销员
            deleteInspector(item, index){
                const _this = this;
                this.$confirm('此操作将删除该核销员, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.delete('/wtcp-booking/checkman/', item.id).then(res => {
                        if (res.status == 1) {
                            _this.inspectorForm.checkmanList.splice(index, 1);
                            _this.$message({type: 'success', message: '删除成功!'});
                        } else {
                            _this.$message({message: res.msg, type: "error"});
                        }
                        _this.pageload = false;
                    })
                }).catch(() => {
                    _this.$message({type: 'info', message: '已取消删除'});
                });
            }
        },
        created: function () {
            this.fileBaseUrl = this.GLOBAL.fileBaseUrl;
            this.dafault_qrcode = require('@/imgbox/default/default2_qrcode.png');
            this.request.getAuth(this);
            this.loadPage();
            this.pageload = false;
        }
    }
</script>
<style lang="less">
    .bookingManagementForm {

        .el-container{
            background-color: #FFFFFF;

            .el-header {
                background-color: #FFFFFF;
                height: 30px !important;

                .el-divider {
                    .el-divider__text {
                        text-align: center;
                        width: 7rem;
                        font-weight: bold;
                    }
                }
            }

            .subscribeAside, .destructionAside {
                height: 250px;
                width: 400px !important;

                .el-main {
                    padding-right: 10px;

                    .el-image {
                        width: 200px;
                        height: 200px;
                        border:1px solid #dedede;
                    }
                }

                .el-aside {
                    padding-top: 20px;
                    width: 150px !important;

                    button{
                        width: 100%;
                        margin: 0px 0px 10px 0px !important;
                    }
                }
            }

            .subscribeIntro, .destructionIntro {
                font-size: 14px;
                font-weight: bold;
            }

            .subscribeIntro {
                color: #67C23A;
            }

            .destructionIntro {
                color: #E5A146;
            }

            .introduce {
                padding: 0px;
            }

            .inspector {
                > button {
                    width: 200px;
                }
                > .el-container > .el-main {
                    padding: 0px;
                }
                .inspectorInfo {
                    float: left;
                    margin: 20px 20px 0px 0px;
                    width: 450px;
                    border: 1px solid #dedede;
                    .el-aside:nth-child(1) {
                        width: 220px !important;
                        padding: 20px;
                        .el-form-item {
                            height: 30px;
                            margin: 0px 0px 12px 0px;
                        }
                        .el-form-item__label {
                            padding: 0px;
                            line-height: 30px;
                        }
                        .el-form-item__content {
                            margin-left: 60px !important;
                            padding: 0px;
                            line-height: 30px;
                        }
                        .el-form-item__error {
                            padding-top: 0px;
                        }
                        label {
                            width: 50px !important;
                            height: 30px;
                            float: left;
                        }
                        button {
                            width: 100%;
                        }
                    }
                    .el-main {
                        padding: 20px 0px 10px 10px;
                        position: relative;
                        .el-image {
                            width: 110px;
                            height: 110px;
                            border: 1px solid #dedede;
                        }

                        .inspectorTips {
                            position: absolute;
                            top: 0;
                            width: 110px;

                            p {
                                margin-top: 45px;
                            }
                        }
                    }

                    .el-aside:nth-child(3) {
                        position: relative;
                        width: 100px !important;
                        padding: 20px 10px 20px 0px;
                        button:nth-child(1) {
                            width: 100%;
                            border-bottom-left-radius: 0;
                            border-top-left-radius: 0;
                        }
                        button:nth-child(2){
                            width: 100%;
                            margin: 0px;
                            border-bottom-left-radius: 0;
                            border-top-left-radius: 0;
                            position: absolute;
                            bottom: 20px;
                            width: 90px;
                            right: 10px;
                        }
                    }
                }
            }
        }

    }


</style>